import React from 'react'
import SelectedPreferences from 'components/SelectedPreferences'
import { Header } from 'semantic-ui-react'
import { GridColumn, Grid } from 'semantic-ui-react'

export const RightPane = ({ selectedPreferences, companyName }) => (
  <GridColumn className="pt5 pb5 mobile hidden">
    <Grid columns={1} container centered padded className="">
      <GridColumn className="onboarding-wizard-pane !pt-[110px]">
        <Header as="h2" className="text-left">
          {`✨ ${companyName} - Simplesat profile`}
        </Header>
        <SelectedPreferences selectedPreferences={selectedPreferences} />
      </GridColumn>
    </Grid>
  </GridColumn>
)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/OnboardingWizard/RightPane.js